import type { FunctionComponent } from 'react';
import { useState } from 'react';
import Tile from '@atlaskit/tile';
import { DEFAULT_SITE_AVATAR_URL } from '../../../definitions/avatar';
import LetterTile from './LetterTile';

export interface SiteTileProps {
  avatarUrl?: string;
  /**
   * Name used to render initials on a deterministic colour when there is no
   * usable avatar. Callers that omit it keep the generic default avatar.
   */
  name?: string;
}

const SiteTile: FunctionComponent<SiteTileProps> = ({ avatarUrl, name }) => {
  const [hasFailed, setHasFailed] = useState(false);
  const src = avatarUrl && !hasFailed ? avatarUrl : null;

  if (!src) {
    return name?.trim() ? (
      <LetterTile name={name} />
    ) : (
      <Tile label="" size="medium" isInset={false}>
        <img src={DEFAULT_SITE_AVATAR_URL} alt="" />
      </Tile>
    );
  }

  return (
    <Tile label="" size="medium" isInset={false}>
      <img src={src} alt="" onError={() => setHasFailed(true)} />
    </Tile>
  );
};

export default SiteTile;
